import React, { useEffect, useState } from "react";
import {
  PlatformUsage,
  PostFieldCounter,
  PostFieldLabel,
} from "components/Posts/PostForm";
import { FIELDS } from "constants/PostFormFields";
import { useDebouncedCallback } from "use-debounce";
import { TextInput } from "ui/ecosystems/forms/inputs";
import { useRegisterFlush } from "../platform-fields/flush-registry";

export const INSTAGRAM_STORY_LINK_STICKER_LABEL_GUIDE = 30;

const StoryLabel = ({
  post,
  selectedPlatform,
  platforms,
  title,
  className = "",
  onChange,
  disabled = false,
}) => {
  const [value, setValue] = useState(
    post && post["storyLabel"] ? post["storyLabel"] : ""
  );
  useEffect(() => {
    if (post && post["storyLabel"]) {
      setValue(post["storyLabel"]);
    }
  }, []);

  const bounce = useDebouncedCallback((value) => {
    const label = post["storyLabel"];
    if (value !== label) {
      setValue(value);
      onChange(value);
    }
  }, 200);
  useRegisterFlush(bounce.flush);

  return (
    <div className={className}>
      <div className="flex flex-col">
        <div className="flex items-center">
          <PostFieldLabel className="mb-2 mr-2">{title}</PostFieldLabel>
          <PlatformUsage
            platforms={platforms}
            field={FIELDS.STORY_LABEL}
            selectedPlatform={selectedPlatform}
          />
        </div>
        <TextInput
          value={value}
          disabled={disabled}
          placeholder="Label for the link sticker (optional, BETA)"
          onChange={(value) => {
            setValue(value);
            bounce(value);
          }}
        />
        <PostFieldCounter
          count={value.length}
          max={100}
          className="flex-grow text-right mt-2 mr-8"
        >
          Characters
        </PostFieldCounter>
        <p className="mb-0 mt-1 text-right text-xs text-neutral-500">
          Instagram may shorten labels longer than about{" "}
          {INSTAGRAM_STORY_LINK_STICKER_LABEL_GUIDE} characters.
        </p>
      </div>
    </div>
  );
};

export default StoryLabel;
